import React from "react";
import { Switch } from "@whatslly/ui-components/v2/BaseElements/Switch";
import { useTranslation } from "react-i18next";
import styles from "./sharedStyles.module.scss";
import type { PartialUser, PermissionInstanceConfigs } from "@whatslly/commons/platformPermissions";
import { getOptionalPermissions } from "@whatslly/commons/platformPermissions";
import { UserPermissions } from "@whatslly/commons/granularPermissions";
import { PermissionsEditor } from "./PermissionsEditor";

interface InvitePlatformSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  user: PartialUser | undefined;
  setPermissions: (permissions: string) => void;
  instanceConfigs?: PermissionInstanceConfigs;
}

export const InvitePlatformSwitch: React.FC<InvitePlatformSwitchProps> = ({ value, onChange, disabled, user, setPermissions, instanceConfigs }) => {
  const { t } = useTranslation();
  const [permissionsState, setPermissionsState] = React.useState<string | undefined>();

  return (
    <div>
      <div className={styles.switchTextContainer}>
        <Switch testId="invite_to_platform_switch" checked={value} onChange={(e) => onChange(e.target.checked)} disabled={disabled} />
        <span>{t("users_management.invite_to_platform")}</span>
      </div>
      <div>
        {value && (
          <PermissionsEditor
            hideTitle
            instanceConfigs={instanceConfigs}
            optionalPermissions={getOptionalPermissions(user)}
            permissions={BigInt(permissionsState ?? UserPermissions.none)}
            setPermissions={(permissions) => {
              setPermissionsState(permissions.toString());
              setPermissions(permissions.toString());
            }}
          />
        )}
      </div>
    </div>
  );
};
